export default "__VITE_ASSET__oATQ3uDI__"